import { render, staticRenderFns } from "./indicatorTable.vue?vue&type=template&id=c16d95ca&scoped=true&"
import script from "./indicatorTable.vue?vue&type=script&lang=js&"
export * from "./indicatorTable.vue?vue&type=script&lang=js&"
import style0 from "./indicatorTable.vue?vue&type=style&index=0&id=c16d95ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16d95ca",
  null
  
)

export default component.exports